import { api } from "./apiBase";

const urlGetStock = "/v3/Stock";

export function stockBySymbolAndCountryApi(accessToken, symbol, country) {
  api.headers.Authorization = `Bearer ${accessToken}`;

  return api.get(`${urlGetStock}/${symbol}&${country}`);
}